import * as React from 'react'

import { cn } from './cn'

export interface LinearProgressProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'color'> {
  variant?: 'determinate' | 'indeterminate'
  value?: number
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'
}

const barColors = {
  primary: 'bg-primary',
  secondary: 'bg-primary',
  error: 'bg-error',
  warning: 'bg-warning',
  info: 'bg-info',
  success: 'bg-success',
}

const LinearProgress = React.forwardRef<HTMLDivElement, LinearProgressProps>(
  (
    {
      variant = 'indeterminate',
      value = 0,
      color = 'primary',
      className,
      ...props
    },
    ref,
  ) => (
    <div
      ref={ref}
      role="progressbar"
      aria-valuenow={variant === 'determinate' ? Math.round(value) : undefined}
      className={cn(
        'relative h-1.5 w-full overflow-hidden rounded-full bg-primary/[0.15]',
        className,
      )}
      {...props}
    >
      {variant === 'determinate' ? (
        <div
          className={cn(
            'h-full rounded-full transition-[width] duration-300',
            barColors[color],
          )}
          style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
        />
      ) : (
        <div
          className={cn(
            'absolute inset-y-0 animate-ps-indeterminate',
            barColors[color],
          )}
        />
      )}
    </div>
  ),
)
LinearProgress.displayName = 'LinearProgress'

export default LinearProgress
